/**
 * Component: SecureChart
 */

export default class SecureChart {
    constructor() {
        this.selectors = {
            root: '[data-secure-chart]',
            column: '.column'
        };

        this.$rootElement = $(this.selectors.root);
        this.$column = this.$rootElement.find(this.selectors.column);
        this.init();
    }
    init() {
        this.$column.on({
            mouseenter: function () {
                const columnClassList = $(this).attr('class');
                const stringIndex = columnClassList.indexOf('column-');
                const columnString = columnClassList.slice(stringIndex, stringIndex + 8);
                if (!$(`.${columnString}`).hasClass('hovered')) {
                    $(`.${columnString}`).addClass('hovered');
                }
            },
            mouseleave: function () {
                const columnClassList = $(this).attr('class');
                const stringIndex = columnClassList.indexOf('column-');
                const columnString = columnClassList.slice(stringIndex, stringIndex + 8);

                if ($(`.${columnString}`).hasClass('hovered')) {
                    $(`.${columnString}`).removeClass('hovered');
                }
            }
        });
    }
}
